import type { FileRow } from './offline-cache'

// "我的文件"列表统一走 v_file_info_mine —— owner 收口(user_id = auth.uid())内建在 view 里,
// 前端不再直查 public.file_info(那会因 file_info_select_visibility 宽 policy 漏入别人的公开
// 文件:D20-rework 后 is_public 默认 true,直查会泄露所有用户的所有公开文件)。
// 详见 db-rules §0.1.2 view-first + migration 20260606000400_v_file_info_mine_add_cover.sql。
//
// size_original / mime_type / thumb_url_list / thumb_url_feed / cover_* 均已在 view 内平坦化,
// 取代此前的 base_file embed + cover 自引用 embed(PostgREST 自引用 FK 从 view embed 歧义无法消解)。
export const MINE_FILE_COLS =
  'id, name, type, subtype, status, parent_id, created_at, base_file_id, mime_type, size_original, thumb_url_list, thumb_url_feed, cover_name, cover_base_file_id, cover_thumb_url_list'

export type MineFileRow = {
  id: string
  name: string
  type: string
  subtype?: string | null
  status: string
  parent_id: string | null
  created_at: string
  base_file_id: string | null
  mime_type: string | null
  size_original: number | null
  thumb_url_list: string | null
  thumb_url_feed: string | null
  cover_name: string | null
  cover_base_file_id: string | null
  cover_thumb_url_list: string | null
}

/** 把 v_file_info_mine 平坦行映射回 FileRow 契约(size / cover 还原)。 */
export function fileRowFromMine(r: MineFileRow): FileRow {
  return {
    id: r.id,
    name: r.name,
    type: r.type,
    subtype: r.subtype ?? null,
    status: r.status,
    parent_id: r.parent_id,
    created_at: r.created_at,
    base_file_id: r.base_file_id ?? null,
    mime_type: r.mime_type ?? null,
    ...(r.size_original != null ? { size: r.size_original } : {}),
    thumb_url_list: r.thumb_url_list ?? null,
    thumb_url_feed: r.thumb_url_feed ?? null,
    cover: r.cover_base_file_id
      ? {
          name: r.cover_name ?? '',
          base_file_id: r.cover_base_file_id,
          thumb_url_list: r.cover_thumb_url_list ?? null,
        }
      : null,
  }
}

/**
 * 根列表置顶「资源包」folder(subtype='pack_root')—— 仅在根目录(parentId===null)调用。
 *
 * 稳定排序:pack_root 行整体提到最前,pack_root 之间及非 pack_root 之间各自保持入参原有相对
 * 顺序(后端已 order by type desc / created_at desc)。纯函数,不修改入参数组。
 *
 * 理论上每用户至多一个 pack_root(惰性创建);多于一个时也全部置顶,行为良性。
 */
export function pinPackRoot<T extends { subtype?: string | null }>(rows: readonly T[]): T[] {
  const packRoots: T[] = []
  const rest: T[] = []
  for (const row of rows) {
    if (row.subtype === 'pack_root') packRoots.push(row)
    else rest.push(row)
  }
  return [...packRoots, ...rest]
}
